// extracted by mini-css-extract-plugin
export default {"tag":"TagsInput_tag__ltI14","active":"TagsInput_active__ku2-v"};